"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _SidenavLink = _interopRequireDefault(require("./SidenavLink"));
var _Typography = _interopRequireDefault(require("../../Typography/Typography"));
var useStyles = function useStyles(_ref) {
  var isSelected = _ref.isSelected,
    isFocused = _ref.isFocused;
  return (0, _core.makeStyles)(function (theme) {
    var borderOffset = 1;
    return {
      linkText: {
        color: theme.palette.common.white,
        fontSize: 14,
        marginLeft: theme.spacing(1)
      },
      root: {
        /** adding a before element in order to have the proper focus styling */

        '&:before': {
          background: isSelected ? theme.palette.common.white : theme.palette.opacity.white[38],
          bottom: 0,
          content: '""',
          display: 'block',
          left: isFocused ? theme.spacing(7) - borderOffset : theme.spacing(7),
          opacity: 1,
          position: 'absolute',
          right: 0,
          top: 0,
          width: 2,
          zIndex: 1
        },
        '&:hover': {
          '&::before': {
            background: theme.palette.common.white
          },
          opacity: 1
        },
        background: isFocused ? theme.palette.opacity.white[14] : 'none',
        border: isFocused ? '1px solid white' : '',
        opacity: isSelected ? 1 : 0.7,
        paddingBottom: isFocused ? theme.spacing(1) - borderOffset : theme.spacing(1),
        paddingLeft: isFocused ? theme.spacing(7) - borderOffset : theme.spacing(7),
        paddingTop: isFocused ? theme.spacing(1) - borderOffset : theme.spacing(1),
        position: 'relative'
      }
    };
  })();
};
var defaultProps = {
  dataMetrics: 'fuse_sidenav_child_tab'
};
var ChildTab = function ChildTab(props) {
  var dataMetrics = props.dataMetrics,
    isSelected = props.isSelected,
    isFocused = props.isFocused,
    onClick = props.onClick,
    route = props.route,
    text = props.text,
    onKeyDown = props.onKeyDown;
  var classes = useStyles({
    isFocused: isFocused,
    isSelected: isSelected
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-metrics": dataMetrics
  }, /*#__PURE__*/_react["default"].createElement(_SidenavLink["default"], {
    route: route,
    onClick: onClick,
    isFocused: isFocused,
    onKeyDown: onKeyDown,
    role: "menuitem"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.linkText
  }, text))));
};
ChildTab.defaultProps = defaultProps;
ChildTab.propTypes = process.env.NODE_ENV !== "production" ? {
  dataMetrics: _propTypes["default"].string,
  isFocused: _propTypes["default"].bool,
  isSelected: _propTypes["default"].bool.isRequired,
  /**
   * Callback function when a ChildTab is clicked
   */
  onClick: _propTypes["default"].func.isRequired,
  onKeyDown: _propTypes["default"].func.isRequired,
  route: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].string.isRequired
} : {};
var _default = ChildTab;
exports["default"] = _default;